export default __webpack_public_path__ + "static/media/Send.1d92db96.svg";